<template>
  <p v-if="!count" class="text-muted-foreground" data-cy="order-check-in-count">
    -
  </p>

  <!-- The column header carries the wording, the pill holds the numbers. -->
  <SBadge v-else :class="tone" data-cy="order-check-in-count">
    {{ count.checkedIn }}/{{ count.total }}
  </SBadge>
</template>

<script setup lang="ts">
import { computed, watchEffect } from "vue";
import { SBadge } from "@smeetz/ui-core";

import { useOrdersCheckInInject } from "../../composables/useOrdersCheckIn";

const props = defineProps<{ row: Record<string, unknown> }>();

const countsApi = useOrdersCheckInInject();

const bookingId = computed<string>(() => String(props.row.id));

// An order with no access ticket keeps the dash: nothing to check in.
const count = computed(() => {
  const entry = countsApi.countsByBooking.value[bookingId.value];

  return entry && entry.total > 0 ? entry : null;
});

// Grey while nobody is in, amber once the order is part way, green when the
// whole order has come in.
const tone = computed(() => {
  if (!count.value || count.value.checkedIn === 0) {
    return "border-transparent bg-muted text-muted-foreground";
  }

  return count.value.checkedIn === count.value.total
    ? "border-transparent bg-green-100 text-green-800"
    : "border-transparent bg-amber-100 text-amber-800";
});

// The table reuses its rows and empties the cache when it fetches again, so
// asking once on mount would leave a reused row without a count.
watchEffect(() => {
  countsApi.requestForId(bookingId.value);
});
</script>
